var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _g2, _path23, _path24, _path25, _path26, _g3, _path27, _path28, _path29, _path30, _g4, _path31, _path32, _path33, _path34, _g5, _path35, _path36, _path37, _path38, _g6, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 481,
    viewBox: "0 0 520 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 520,
    height: 481
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520 0H0V480.976H520V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_439)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445.854 0H75.122C70.8114 0 67.3171 3.49436 67.3171 7.80488V329.756C67.3171 334.067 70.8114 337.561 75.122 337.561H445.854C450.164 337.561 453.659 334.067 453.659 329.756V7.80488C453.659 3.49436 450.164 0 445.854 0Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3171 7.80488C67.3171 3.49463 70.8117 0 75.122 0H445.854C450.164 0 453.659 3.49463 453.659 7.80488V26.3415H67.3171V7.80488Z",
    fill: "#C5CFD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 17.561C82.1551 17.561 83.9024 15.8137 83.9024 13.6585C83.9024 11.5034 82.1551 9.7561 80 9.7561C77.8449 9.7561 76.0976 11.5034 76.0976 13.6585C76.0976 15.8137 77.8449 17.561 80 17.561Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7073 17.561C93.8624 17.561 95.6097 15.8137 95.6097 13.6585C95.6097 11.5034 93.8624 9.7561 91.7073 9.7561C89.5522 9.7561 87.8048 11.5034 87.8048 13.6585C87.8048 15.8137 89.5522 17.561 91.7073 17.561Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.415 17.561C105.57 17.561 107.317 15.8137 107.317 13.6585C107.317 11.5034 105.57 9.7561 103.415 9.7561C101.26 9.7561 99.5122 11.5034 99.5122 13.6585C99.5122 15.8137 101.26 17.561 103.415 17.561Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M430.244 128.78H377.561C373.25 128.78 369.756 132.275 369.756 136.585V310.244C369.756 314.554 373.25 318.049 377.561 318.049H430.244C434.554 318.049 438.049 314.554 438.049 310.244V136.585C438.049 132.275 434.554 128.78 430.244 128.78Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M416.585 146.341H391.22C389.064 146.341 387.317 148.089 387.317 150.244V167.805C387.317 169.96 389.064 171.707 391.22 171.707H416.585C418.741 171.707 420.488 169.96 420.488 167.805V150.244C420.488 148.089 418.741 146.341 416.585 146.341Z",
    fill: "#DDE3E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M416.585 179.512H391.22C389.064 179.512 387.317 181.259 387.317 183.415V200C387.317 202.155 389.064 203.902 391.22 203.902H416.585C418.741 203.902 420.488 202.155 420.488 200V183.415C420.488 181.259 418.741 179.512 416.585 179.512Z",
    fill: "#AFB9C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M416.585 211.707H391.22C389.064 211.707 387.317 213.455 387.317 215.61V232.195C387.317 234.35 389.064 236.098 391.22 236.098H416.585C418.741 236.098 420.488 234.35 420.488 232.195V215.61C420.488 213.455 418.741 211.707 416.585 211.707Z",
    fill: "#DDE3E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M416.585 276.098H391.22C389.064 276.098 387.317 277.845 387.317 280V296.585C387.317 298.741 389.064 300.488 391.22 300.488H416.585C418.741 300.488 420.488 298.741 420.488 296.585V280C420.488 277.845 418.741 276.098 416.585 276.098Z",
    fill: "#DDE3E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M416.585 243.902H391.22C389.064 243.902 387.317 245.65 387.317 247.805V264.39C387.317 266.546 389.064 268.293 391.22 268.293H416.585C418.741 268.293 420.488 266.546 420.488 264.39V247.805C420.488 245.65 418.741 243.902 416.585 243.902Z",
    fill: "#C5CFD6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M430.244 41.9512H377.561C373.25 41.9512 369.756 45.4456 369.756 49.7561V113.171C369.756 117.481 373.25 120.976 377.561 120.976H430.244C434.554 120.976 438.049 117.481 438.049 113.171V49.7561C438.049 45.4456 434.554 41.9512 430.244 41.9512Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.902 87.8048C412.524 87.8048 419.512 80.8165 419.512 72.1951C419.512 63.5736 412.524 56.5853 403.902 56.5853C395.281 56.5853 388.293 63.5736 388.293 72.1951C388.293 80.8165 395.281 87.8048 403.902 87.8048Z",
    fill: "#DDE3E9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M425.366 91.7073H382.439C380.823 91.7073 379.512 93.0177 379.512 94.6341C379.512 96.2505 380.823 97.5609 382.439 97.5609H425.366C426.982 97.5609 428.293 96.2505 428.293 94.6341C428.293 93.0177 426.982 91.7073 425.366 91.7073Z",
    fill: "#DDE3E9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M417.561 101.463H390.244C388.627 101.463 387.317 102.774 387.317 104.39C387.317 106.007 388.627 107.317 390.244 107.317H417.561C419.177 107.317 420.488 106.007 420.488 104.39C420.488 102.774 419.177 101.463 417.561 101.463Z",
    fill: "#DDE3E9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M358.049 41.9512H86.8293C84.674 41.9512 82.9268 43.6984 82.9268 45.8536V83.9024C82.9268 86.0576 84.674 87.8048 86.8293 87.8048H358.049C360.204 87.8048 361.951 86.0576 361.951 83.9024V45.8536C361.951 43.6984 360.204 41.9512 358.049 41.9512Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11_439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 55,
    width: 224,
    height: 20
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M314.146 55.7073H91.7073V74.2439H314.146V55.7073Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.219 55.7073H94.6341C93.0177 55.7073 91.7073 57.0177 91.7073 58.6341V59.6585C91.7073 61.2749 93.0177 62.5853 94.6341 62.5853H311.219C312.836 62.5853 314.146 61.2749 314.146 59.6585V58.6341C314.146 57.0177 312.836 55.7073 311.219 55.7073Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.089 67.1707H94.6341C93.0177 67.1707 91.7073 68.4811 91.7073 70.0975V71.1219C91.7073 72.7384 93.0177 74.0488 94.6341 74.0488H238.089C239.705 74.0488 241.016 72.7384 241.016 71.1219V70.0975C241.016 68.4811 239.705 67.1707 238.089 67.1707Z",
    fill: "#DDE3E9"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 71.7073C335.903 71.7073 338.961 68.6497 338.961 64.878C338.961 61.1063 335.903 58.0488 332.132 58.0488C328.36 58.0488 325.302 61.1063 325.302 64.878C325.302 68.6497 328.36 71.7073 332.132 71.7073Z",
    fill: "#DDE3E9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 67.805C333.748 67.805 335.059 66.4947 335.059 64.8781C335.059 63.2615 333.748 61.9513 332.132 61.9513C330.515 61.9513 329.205 63.2615 329.205 64.8781C329.205 66.4947 330.515 67.805 332.132 67.805Z",
    fill: "#F2F2F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M358.049 95.6097H86.8293C84.674 95.6097 82.9268 97.3569 82.9268 99.5122V129.756C82.9268 131.911 84.674 133.659 86.8293 133.659H358.049C360.204 133.659 361.951 131.911 361.951 129.756V99.5122C361.951 97.3569 360.204 95.6097 358.049 95.6097Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11_439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 107,
    width: 224,
    height: 16
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M314.146 107.024H91.7073V122.634H314.146V107.024Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.293 107.024H94.561C92.9849 107.024 91.7073 108.302 91.7073 109.878C91.7073 111.454 92.9849 112.732 94.561 112.732H311.293C312.869 112.732 314.146 111.454 314.146 109.878C314.146 108.302 312.869 107.024 311.293 107.024Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.162 116.537H94.561C92.9849 116.537 91.7073 117.814 91.7073 119.39C91.7073 120.966 92.9849 122.244 94.561 122.244H238.162C239.738 122.244 241.016 120.966 241.016 119.39C241.016 117.814 239.738 116.537 238.162 116.537Z",
    fill: "#DDE3E9"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 121.463C335.903 121.463 338.961 118.406 338.961 114.634C338.961 110.862 335.903 107.805 332.132 107.805C328.36 107.805 325.302 110.862 325.302 114.634C325.302 118.406 328.36 121.463 332.132 121.463Z",
    fill: "#DDE3E9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 117.561C333.748 117.561 335.059 116.251 335.059 114.634C335.059 113.018 333.748 111.707 332.132 111.707C330.515 111.707 329.205 113.018 329.205 114.634C329.205 116.251 330.515 117.561 332.132 117.561Z",
    fill: "#F2F2F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M358.049 141.463H86.8293C84.674 141.463 82.9268 143.211 82.9268 145.366V175.61C82.9268 177.765 84.674 179.512 86.8293 179.512H358.049C360.204 179.512 361.951 177.765 361.951 175.61V145.366C361.951 143.211 360.204 141.463 358.049 141.463Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11_439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 152,
    width: 224,
    height: 17
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.146 152.878H91.7073V168.488H314.146V152.878Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.293 152.878H94.561C92.9849 152.878 91.7073 154.156 91.7073 155.732C91.7073 157.308 92.9849 158.585 94.561 158.585H311.293C312.869 158.585 314.146 157.308 314.146 155.732C314.146 154.156 312.869 152.878 311.293 152.878Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.162 162.39H94.561C92.9849 162.39 91.7073 163.668 91.7073 165.244C91.7073 166.82 92.9849 168.098 94.561 168.098H238.162C239.738 168.098 241.016 166.82 241.016 165.244C241.016 163.668 239.738 162.39 238.162 162.39Z",
    fill: "#DDE3E9"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 167.317C335.903 167.317 338.961 164.26 338.961 160.488C338.961 156.716 335.903 153.659 332.132 153.659C328.36 153.659 325.302 156.716 325.302 160.488C325.302 164.26 328.36 167.317 332.132 167.317Z",
    fill: "#DDE3E9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 163.415C333.748 163.415 335.059 162.104 335.059 160.488C335.059 158.871 333.748 157.561 332.132 157.561C330.515 157.561 329.205 158.871 329.205 160.488C329.205 162.104 330.515 163.415 332.132 163.415Z",
    fill: "#AFB9C5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M358.049 279.024H86.8293C84.674 279.024 82.9268 280.772 82.9268 282.927V313.171C82.9268 315.326 84.674 317.073 86.8293 317.073H358.049C360.204 317.073 361.951 315.326 361.951 313.171V282.927C361.951 280.772 360.204 279.024 358.049 279.024Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11_439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 290,
    width: 224,
    height: 17
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M314.146 290.439H91.7073V306.049H314.146V290.439Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.293 290.439H94.561C92.9849 290.439 91.7073 291.717 91.7073 293.293C91.7073 294.869 92.9849 296.146 94.561 296.146H311.293C312.869 296.146 314.146 294.869 314.146 293.293C314.146 291.717 312.869 290.439 311.293 290.439Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.162 299.951H94.561C92.9849 299.951 91.7073 301.229 91.7073 302.805C91.7073 304.381 92.9849 305.658 94.561 305.658H238.162C239.738 305.658 241.016 304.381 241.016 302.805C241.016 301.229 239.738 299.951 238.162 299.951Z",
    fill: "#DDE3E9"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 304.878C335.903 304.878 338.961 301.82 338.961 298.049C338.961 294.277 335.903 291.219 332.132 291.219C328.36 291.219 325.302 294.277 325.302 298.049C325.302 301.82 328.36 304.878 332.132 304.878Z",
    fill: "#DDE3E9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 300.976C333.748 300.976 335.059 299.665 335.059 298.049C335.059 296.432 333.748 295.122 332.132 295.122C330.515 295.122 329.205 296.432 329.205 298.049C329.205 299.665 330.515 300.976 332.132 300.976Z",
    fill: "#F2F2F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M358.049 233.171H86.8293C84.674 233.171 82.9268 234.918 82.9268 237.073V267.317C82.9268 269.472 84.674 271.219 86.8293 271.219H358.049C360.204 271.219 361.951 269.472 361.951 267.317V237.073C361.951 234.918 360.204 233.171 358.049 233.171Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11_439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 244,
    width: 224,
    height: 17
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M314.146 244.585H91.7073V260.195H314.146V244.585Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.293 244.585H94.561C92.9849 244.585 91.7073 245.863 91.7073 247.439C91.7073 249.015 92.9849 250.293 94.561 250.293H311.293C312.869 250.293 314.146 249.015 314.146 247.439C314.146 245.863 312.869 244.585 311.293 244.585Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.162 254.098H94.561C92.9849 254.098 91.7073 255.375 91.7073 256.951C91.7073 258.527 92.9849 259.805 94.561 259.805H238.162C239.738 259.805 241.016 258.527 241.016 256.951C241.016 255.375 239.738 254.098 238.162 254.098Z",
    fill: "#DDE3E9"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 259.024C335.903 259.024 338.961 255.967 338.961 252.195C338.961 248.423 335.903 245.366 332.132 245.366C328.36 245.366 325.302 248.423 325.302 252.195C325.302 255.967 328.36 259.024 332.132 259.024Z",
    fill: "#DDE3E9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 255.122C333.748 255.122 335.059 253.812 335.059 252.195C335.059 250.578 333.748 249.268 332.132 249.268C330.515 249.268 329.205 250.578 329.205 252.195C329.205 253.812 330.515 255.122 332.132 255.122Z",
    fill: "#F2F2F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M358.049 187.317H86.8293C84.674 187.317 82.9268 189.064 82.9268 191.22V221.463C82.9268 223.619 84.674 225.366 86.8293 225.366H358.049C360.204 225.366 361.951 223.619 361.951 221.463V191.22C361.951 189.064 360.204 187.317 358.049 187.317Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11_439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 198,
    width: 224,
    height: 17
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M314.146 198.732H91.7073V214.341H314.146V198.732Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.293 198.732H94.561C92.9849 198.732 91.7073 200.009 91.7073 201.585C91.7073 203.161 92.9849 204.439 94.561 204.439H311.293C312.869 204.439 314.146 203.161 314.146 201.585C314.146 200.009 312.869 198.732 311.293 198.732Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.162 208.244H94.561C92.9849 208.244 91.7073 209.522 91.7073 211.098C91.7073 212.674 92.9849 213.951 94.561 213.951H238.162C239.738 213.951 241.016 212.674 241.016 211.098C241.016 209.522 239.738 208.244 238.162 208.244Z",
    fill: "#DDE3E9"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 213.171C335.903 213.171 338.961 210.113 338.961 206.341C338.961 202.57 335.903 199.512 332.132 199.512C328.36 199.512 325.302 202.57 325.302 206.341C325.302 210.113 328.36 213.171 332.132 213.171Z",
    fill: "#DDE3E9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.132 209.268C333.748 209.268 335.059 207.958 335.059 206.342C335.059 204.725 333.748 203.415 332.132 203.415C330.515 203.415 329.205 204.725 329.205 206.342C329.205 207.958 330.515 209.268 332.132 209.268Z",
    fill: "#F2F2F2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.166 177.863C125.204 180.426 130.902 181.274 133.378 180.254C139.584 177.694 136.876 154.123 130.592 145.564C124.308 137.005 98.1259 136.569 99.4127 155.097C99.8596 161.527 103.341 166.832 107.954 170.912L105.489 204.923L126.126 202.022L119.166 177.863Z",
    fill: "#B28B67"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.023 136.624C118.083 136.164 113.949 136.449 112.255 136.887C112.905 134.41 112.928 131.748 112.254 129.255C111.599 126.831 110.199 124.887 108.867 122.83C108.254 121.882 107.578 120.948 106.672 120.284C105.75 119.608 104.651 119.23 103.539 119.133C102.401 119.033 101.252 119.216 100.181 119.602C99.7073 119.773 99.3005 120.057 98.839 120.248C98.3668 120.444 98.0859 120.171 97.6868 119.914C96.7249 119.294 95.4166 119.104 94.3132 119.126C93.0751 119.15 91.8381 119.511 90.7337 120.073C89.6576 120.62 88.6615 121.403 87.9737 122.437C87.6673 122.896 87.402 123.409 87.2595 123.953C87.202 124.176 87.2049 124.303 87.0039 124.41C86.8195 124.509 86.5912 124.543 86.399 124.64C84.5434 125.572 83.0888 127.306 82.4527 129.361C82.081 130.559 82.1083 132.574 82.4888 134.782C82.8693 136.991 85.6927 142.497 87.8683 144.345C89.8107 145.994 92.4507 146.891 94.9073 147.101C93.5805 149.123 92.8449 151.52 92.3893 153.916C91.8937 156.52 91.7346 159.175 91.9112 161.832C92.079 164.357 92.4332 167.003 93.3649 169.366C94.2361 171.576 95.6751 173.288 97.8049 174.202C98.7815 174.62 99.8059 174.895 100.831 175.133C101.842 175.367 102.854 175.59 103.888 175.655C105.843 175.78 108.024 175.406 109.276 173.692C109.728 173.073 110.212 172.308 110.503 171.59C110.609 171.332 110.67 171.164 110.469 170.954C110.228 170.702 109.872 170.534 109.582 170.351C107.932 169.311 106.783 167.775 106.275 165.828C105.759 163.853 105.936 161.185 107.771 160.033C110.036 158.612 112.872 159.48 115.183 160.335C115.645 156.994 117.113 153.838 119.845 151.951C122.868 149.863 126.573 149.148 129.718 147.28C130.538 146.793 131.366 146.255 131.902 145.421C132.127 145.073 132.384 144.626 132.434 144.201C132.499 143.642 132.086 143.239 131.758 142.856C130.016 140.828 123.964 137.086 121.023 136.624Z",
    fill: "#191847"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.878 273.102L177.398 380.643L225.769 471.56H236.187L155.142 273.102H112.878Z",
    fill: "#997659"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.016 466.487C220.969 466.035 219.728 466.499 219.342 467.572C218.721 469.304 217.941 471.757 217.941 473.166C217.941 475.507 218.724 480 218.724 480C221.449 480 267.698 480 267.698 480C267.698 480 269.606 473.708 265.494 473.206C261.381 472.705 258.661 472.301 258.661 472.301L235.997 462.227C235.496 462.005 234.909 462.239 234.7 462.746L233.278 466.183C233.278 466.183 229.471 467.954 227.091 467.954C225.705 467.954 223.564 467.155 222.016 466.487Z",
    fill: "#E4E4E4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.335 457.001L232.427 450.941C232.427 450.941 219.222 411.586 200.06 364.323C180.896 317.06 158.898 273.102 158.898 273.102H102.149C102.149 273.102 126.607 328.706 154.006 374.149C181.404 419.592 212.335 457.001 212.335 457.001Z",
    fill: "#DB2721"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.638 273.102C102.548 310.893 90.8039 359.175 89.6946 360.664C88.9561 361.658 62.3542 370.545 9.88977 387.326L12.1405 396.486C74.7044 387.486 107.67 380.503 111.038 375.539C116.09 368.091 141.313 309.256 151.083 273.102H108.638Z",
    fill: "#B28B67"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3317 379.408L32.2966 394.161C79.0908 398.253 107.762 395.296 118.311 385.291C128.861 375.286 140.884 337.89 154.381 273.102H100.269C91.7171 326.154 86.9366 353.794 85.9269 356.021C84.9161 358.248 65.7181 366.044 28.3317 379.408Z",
    fill: "#FF4133"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7756 385.94C14.041 384.828 13.3659 383.683 12.2381 383.49C10.4196 383.181 7.86346 382.843 6.47419 383.087C4.16102 383.493 -0.140442 385.042 -0.140442 385.042C0.332729 387.717 8.36298 433.127 8.36298 433.127C8.36298 433.127 14.9103 433.908 14.6908 429.782C14.4722 425.657 14.3991 422.916 14.3991 422.916L20.4127 398.922C20.5464 398.387 20.2118 397.849 19.6742 397.731L16.0352 396.932C16.0352 396.932 13.6244 393.502 13.2108 391.165C12.9708 389.809 13.3854 387.575 13.7756 385.94Z",
    fill: "#E4E4E4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.919 196.783L146.365 217.274L159.044 227.519L177.947 204.675C188.931 199.931 193.832 196.9 192.653 195.583C191.658 194.473 190.338 194.702 189.121 194.913C188.174 195.078 187.29 195.231 186.672 194.732C185.262 193.592 186.956 188.675 188.765 184.077C190.573 179.479 188.051 180.212 186.665 181.031C182.305 184.959 178.057 190.21 173.919 196.783ZM207.141 215.432L195.04 224.455L197.63 237.466C197.63 237.466 205.263 230.164 212.281 227.106C221.231 223.208 224.722 220.701 228.461 214.28C230.462 210.844 231.654 204.335 229.052 202.635C228.053 201.983 224.998 204.284 221.881 206.632C219.505 208.421 217.094 210.238 215.529 210.795C213.423 211.545 213.282 208.706 213.171 206.438C213.09 204.811 213.024 203.476 212.257 203.973C208.428 204.578 207.141 215.432 207.141 215.432Z",
    fill: "#997659"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.32 215.687C141.758 214.107 155.388 209.947 168.94 198.444L176.607 210.61C167.774 222.203 154.519 232.572 141.856 233.991C131.876 235.109 125.111 223.836 131.32 215.687Z",
    fill: "#2026A2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.631 308.626C105.511 308.732 96.2127 308.827 90.9503 310.651C82.1161 291.844 85.4185 278.758 88.4663 266.677C90.3034 259.396 92.0488 252.48 90.9893 244.898C87.9025 222.818 100.908 186.335 103.524 185.967L104.275 185.861L125.008 182.947L127.381 182.614C130.369 196.127 137 210.279 143.674 224.523C145.232 227.85 146.793 231.18 148.311 234.51C166.201 235.997 202.781 216.928 202.781 216.928C202.781 216.928 215.319 235.609 215.785 244.249C195.016 259.068 176.541 266.972 160.765 269.539C162.582 278.829 162.692 287.898 159.996 296.576C156.385 308.204 134.571 308.43 115.631 308.626Z",
    fill: "#1F28CF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.064 177.632C368.895 181.671 363.611 183.965 360.955 183.619C354.298 182.753 350.814 159.285 354.667 149.391C358.522 139.497 383.7 132.299 387.252 150.529C388.484 156.855 386.496 162.881 383.095 168.015L394.278 200.23L373.595 202.77L374.064 177.632Z",
    fill: "#B28B67"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.143 137.247C367.815 136.467 375.117 135.26 376.471 135.094C377.336 134.987 378.298 135.069 378.713 134.214C379.053 133.514 378.764 132.436 378.797 131.668C378.835 130.777 378.936 129.888 379.039 129.002C379.333 126.479 379.945 124.039 380.935 121.697C382.79 117.302 385.853 113.663 389.987 111.257C394.554 108.599 399.949 107.457 405.185 107.239C410.788 107.006 416.034 108.215 421.483 109.29C426.676 110.314 431.983 110.317 437.105 108.876C442.267 107.425 445.893 104.095 449.998 100.853C454.201 97.5327 459.17 95.0888 464.59 94.8449C469.65 94.6175 474.523 96.1132 479.006 98.361C483.2 100.463 486.781 103.174 489.123 107.318C491.643 111.778 492.274 116.934 489.588 121.477C485.696 128.063 477.288 130.675 470.114 131.399C465.965 131.818 461.809 131.564 457.734 130.673C452.3 129.486 447.417 126.942 442.234 125.028C439.802 124.13 437.318 123.452 434.754 123.059C432.266 122.677 429.86 122.658 427.86 124.373C425.744 126.188 423.864 127.947 421.347 129.229C418.933 130.46 416.318 131.303 413.621 131.614C408.377 132.217 403.011 131.223 397.787 130.758C393.527 130.379 388.978 130.038 384.851 131.412C383.129 131.985 380.641 133.038 380.227 134.946C391.199 135.568 397.04 148.285 395.207 158.372C394.218 163.816 385.153 171.151 380.997 168.862C378.365 167.414 379.551 164.94 380.316 163.31C381.78 160.188 381.944 156.388 378.33 154.783C375.213 153.4 372.666 157.908 372.608 157.91C371.802 157.945 364.427 154.903 358.98 149.813C354.326 150.665 353.236 147.671 354.046 145.014C354.856 142.355 361.453 138.326 365.143 137.247Z",
    fill: "#191847"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.719 273.102C417.153 294.406 316.293 357.128 315.704 358.888C315.312 360.061 347.099 433.061 347.099 433.061L338.282 436.477C338.282 436.477 289.527 359.165 292.031 350.927C295.617 339.133 370.287 273.329 370.287 273.329L418.719 273.102Z",
    fill: "#B28B67"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.779 422.07L330.383 427.294C300.03 393.15 288.133 364.977 290.301 350.623C292.471 336.269 368.288 273.154 368.288 273.154H419.751C417.995 322.492 324.51 359.076 323.26 361.178C322.01 363.281 334.315 383.872 344.779 422.07Z",
    fill: "#2F3676"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.581 431.454C348.411 430.671 349.737 430.684 350.466 431.561C351.645 432.977 353.22 435.016 353.702 436.339C354.505 438.539 355.311 443.028 355.311 443.028C352.751 443.957 309.292 459.728 309.292 459.728C309.292 459.728 305.34 454.466 309.032 452.592C312.725 450.718 315.142 449.411 315.142 449.411L332.982 432.218C333.378 431.837 334.01 431.858 334.38 432.262L336.895 435.007C336.895 435.007 341.08 435.373 343.317 434.561C344.619 434.089 346.355 432.609 347.581 431.454Z",
    fill: "#E4E4E4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.122 273.102L452.053 380.643L496.213 471.56H485.794L371.805 273.102H407.122Z",
    fill: "#997659"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.219 466.487C495.265 466.035 496.506 466.499 496.892 467.572C497.513 469.304 498.293 471.757 498.293 473.166C498.293 475.507 497.51 480 497.51 480C494.785 480 448.537 480 448.537 480C448.537 480 446.628 473.708 450.74 473.206C454.854 472.705 457.574 472.301 457.574 472.301L480.237 462.227C480.739 462.005 481.325 462.239 481.535 462.746L482.956 466.183C482.956 466.183 486.763 467.954 489.143 467.954C490.529 467.954 492.67 467.155 494.219 466.487Z",
    fill: "#E4E4E4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.224 452.673L469.074 457.001C451.174 430.764 376.262 323.183 368.049 273.102H419.587C447.016 309.305 475.162 426.002 492.224 452.673Z",
    fill: "#5C63AB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.847 247.068L327.753 256.907L319.345 270.867L293.763 255.861C281.819 255.156 276.175 253.983 276.833 252.343C277.387 250.96 278.706 250.724 279.922 250.506C280.868 250.338 281.751 250.179 282.161 249.499C283.097 247.945 279.821 243.904 276.547 240.202C273.274 236.499 275.895 236.326 277.478 236.622C282.919 238.823 288.709 242.305 294.847 247.068ZM437.234 250.833L454.465 245.172C470.306 275.174 479.565 291.544 482.239 294.282C484.201 296.29 495.32 300.717 502.746 302.899C505.728 303.774 505.413 306.233 504.676 307.098C500.03 312.554 494.954 311.464 489.429 310.279C487.83 309.936 486.193 309.584 484.518 309.381C480.181 308.857 479.166 311.172 478.206 313.359C477.356 315.296 476.55 317.133 473.522 316.811C473.585 316.219 473.67 315.553 473.762 314.834C474.357 310.191 475.234 303.342 472.25 299.793C470.718 297.972 459.046 281.652 437.234 250.833Z",
    fill: "#B28B67"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.717 187.358L373.108 186.998C358.804 204.69 356.811 243.217 346.607 249.537C336.959 255.513 321.901 252.726 303.91 248.675L300.076 261.079C317.808 276.046 352.917 286.218 365.438 276.413C385.457 260.735 384.736 213.607 380.717 187.358Z",
    fill: "#DB2721"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.668 276.74C424.668 276.74 379.847 282.243 358.729 284.836C355.716 285.206 355.751 280.799 355.918 278.556C357.843 252.677 374.123 223.037 369.707 187.078L388.362 181.769C407.191 205.062 416.445 235.453 424.668 276.74Z",
    fill: "#DDE3E9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.372 181.645L389.589 181.617C435.468 202.59 466.24 240.055 481.901 294.011L468.412 298.406C457.95 288.896 444.515 272.879 428.104 250.356C434.017 264.412 438.861 278.977 441.535 292.984L382.179 300.272C367.134 272.732 382.059 182.542 382.059 182.542L386.156 182.04L389.372 181.645Z",
    fill: "#FF4133"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.478 184.106C227.477 184.111 227.477 184.117 227.475 184.123C227.477 184.118 227.476 184.097 227.478 184.106Z",
    fill: "#C5CFD6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.475 184.114C227.475 184.114 227.475 184.118 227.476 184.12C227.474 184.115 227.479 184.098 227.475 184.114Z",
    fill: "#C5CFD6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.489 184.026C227.487 184.047 227.482 184.067 227.48 184.088C227.481 184.077 227.483 184.069 227.484 184.059C227.447 184.329 227.47 184.153 227.489 184.026Z",
    fill: "#C5CFD6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.481 184.089C227.48 184.099 227.478 184.109 227.477 184.119C227.462 184.18 227.481 184.089 227.481 184.089Z",
    fill: "#C5CFD6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.473 184.123C227.47 184.136 227.489 184.071 227.473 184.123V184.123Z",
    fill: "#C5CFD6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.476 184.115L227.477 184.112L227.476 184.115Z",
    fill: "#C5CFD6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M258.088 122.392L170.998 144.106C168.907 144.627 167.634 146.745 168.156 148.836L181.845 203.741C182.366 205.832 184.484 207.105 186.576 206.583L273.666 184.869C275.757 184.348 277.029 182.23 276.508 180.139L262.819 125.234C262.297 123.143 260.179 121.87 258.088 122.392Z",
    fill: "#2B44FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.538 154.375L191.33 205.673L245.932 192.059L207.538 154.375Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.659 159.274L222.644 197.865L270.916 185.83L238.659 159.274Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.097 157.135C254.063 155.897 257.085 150.866 255.847 145.899C254.609 140.933 249.579 137.91 244.612 139.148C239.645 140.387 236.623 145.417 237.862 150.383C239.1 155.35 244.13 158.373 249.097 157.135Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/HeroImage.822406a2ac19d7adc90508c5fb9ed9fb.svg";
export { ForwardRef as ReactComponent };